module.exports = __webpack_public_path__ + "media/images/promo-112fa1d5b9f86392db165457a2fc9757.jpg";